import { useEffect, useMemo, useState } from 'react';
import { hrApi } from '@/api/hr.api';
import { SearchableSelect } from '@/components/ui/SearchableSelect';
import type { SelectOption } from '@/components/ui/Select';
import type { HrTrainingCourse } from '@/types/hr';
import { showApiError } from '@/utils/apiError';

export function TrainingCourseSelect({
  label = 'Course',
  value = '',
  onChange,
  placeholder = 'Select course',
  className,
  required,
}: {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  required?: boolean;
}) {
  const [courses, setCourses] = useState<HrTrainingCourse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    hrApi
      .listTrainingCourses()
      .then(setCourses)
      .catch((err) => showApiError(err, 'Failed to load courses'))
      .finally(() => setLoading(false));
  }, []);

  const options: SelectOption[] = useMemo(
    () =>
      courses.map((course) => ({
        value: String(course.id),
        label: course.category ? `${course.title} (${course.category})` : course.title,
      })),
    [courses],
  );

  return (
    <SearchableSelect
      className={className}
      label={label}
      required={required}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      loading={loading}
      searchPlaceholder="Search courses…"
      emptyMessage="No courses found"
    />
  );
}
